import { render } from "./CustomerDocumentsModal.html?vue&type=template&id=44a0c63a&scoped=true"
import script from "./CustomerDocumentsModal.js?vue&type=script&lang=js"
export * from "./CustomerDocumentsModal.js?vue&type=script&lang=js"

import "./CustomerDocumentsModal.css?vue&type=style&index=0&id=44a0c63a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a0c63a"]])

export default __exports__